<template>
  <div v-if="isShow">
    <slot></slot>
  </div>
</template>
<script>
import API from "../../../../service/index";
export default {
  props: {
    custype: {
      type: String,
      default: () => {
        return "";
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    authlist:{
        type: Object
    }
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    /***
     * type
     * apply 新增删除编辑
     * audit 审核
     */
    auth(type, year, quarter, authList) {
      for (let key in authList) {
        const yearkey = key.substring(0, key.lastIndexOf("-"));
        const quarterkey = key.substring(key.indexOf("-") + 1, key.length);
        // console.log('-----键值年：', yearkey);
        // console.log('-----键值季度:', quarterkey);
        // console.log('----年:', year);
        // console.log('----季度:', quarter);
        // 传进来的 年 季度 对等，则应该 控制 对等年 季度 的开关
        const roleLevel = JSON.parse(localStorage.getItem('appraiseNewLocalauthority'))
        console.log('authList[key].audit',roleLevel.roleLevel)
        if (yearkey == year && quarter == quarterkey) {
          if (roleLevel.roleLevel == 1) {
            this.getAuth(authList[key].audit);
          } else {
            const value = (authList[key].audit === 'on' && authList[key].applyArea[this.$route.query.area] === 'on') ? 'on' : 'off';
            this.getAuth(value);
          }
          //  console.log('----应该会打印很多次才对撒');
          // if (type === "apply") {
          //   if (authList[key].apply === "on") {
          //     this.isShow = true;
          //     return true;
          //   } else {
          //     this.isShow = false;
          //     return false;
          //   }
          // } else if (type === "audit") {
          //   if (authList[key].audit === "on") {
          //     this.isShow = true;

          //     return true;
          //   } else {
          //     this.isShow = true;
          //     return false;
          //   }
          // }
          //   console.log("------值apply：", authList[key].apply);
          //   console.log("-----值audit：", authList[key].audit);
        }
      }
    },
    getAuth(verify) {
      switch(verify) {
        case 'on' :
          this.isShow = true;
          break;
        case 'off' :
          this.isShow = false;
          break;
        default :
        this.isShow = false;
      }
    }
  },
  mounted() {
    this.auth(this.custype, this.year, this.quarter, this.authlist);
  },
};
</script>